import { inject, Injectable } from '@angular/core';
import { AnalyticsService } from '@lx/quote-tool/shared/services';
import { AyaQuoteLeadInput, QuoteLeadOrigin, QuoteLeadOutput } from '@lx/quote-tool/shared/types';
import { LeadsControllerApiService } from '@lx/shared/api/services';
import { getLocale } from '@lx/shared/i18n';
import { getCompanyHeader } from '@lx/shared/tokens';
import { Observable } from 'rxjs';
import { withBaseLeadPayload } from '../mixins/base-lead-payload.mixin';
import { QuoteToolLiteState } from '../store';

@Injectable({
  providedIn: 'root',
})
export class AyaLeadService {
  private readonly leadsControllersService = inject(LeadsControllerApiService);
  private readonly analyticsService = inject(AnalyticsService);
  private readonly companyHeader = getCompanyHeader();
  private readonly locale = getLocale();
  private readonly buildBaseLeadPayload = withBaseLeadPayload({
    analyticsService: this.analyticsService,
    locale: this.locale,
  }).buildBaseLeadPayload;

  createLead(state: Partial<QuoteToolLiteState>, formOrigin?: QuoteLeadOrigin): Observable<QuoteLeadOutput> {
    return this.leadsControllersService.createAyaLead(this.locale, this.companyHeader, this.buildLeadPayload(state, formOrigin));
  }

  private buildLeadPayload(state: Partial<QuoteToolLiteState>, formOrigin?: QuoteLeadOrigin): AyaQuoteLeadInput {
    const { selectedCourse, selectedAccommodation, selectedAyaDuration, selectedSchoolLocation, selectedStartDate } = state;
    return {
      ...this.buildBaseLeadPayload(state, formOrigin),
      ayaQuoteData: {
        productCode: selectedCourse?.code,
        schoolCode: selectedSchoolLocation?.schoolCode,
        duration: selectedAyaDuration?.months,
        startDate: selectedStartDate,
        accommodationType: selectedAccommodation?.type,
      },
    };
  }
}
